

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import Utils from "@/utilities/Utils";

    @Component({ })
    export default class PrintDatePicker extends Vue {

        @Prop({ default: null })
        value!: Date;

        @Prop({ default: null })
        minValue!: Date|null;

        @Prop({ default: null })
        maxValue!: Date|null;

        get dateText(): string {
            return Utils.pickerDateText(this.value);
        }

        get hasValue(): boolean {
            return Utils.hasDateValue(this.value);
        }

        get minText(): string|null {
            return Utils.hasDateValue(this.minValue)
                ? Utils.pickerDateText(this.minValue)
                : null;
        }

        get maxText(): string|null {
            return Utils.hasDateValue(this.maxValue)
                ? Utils.pickerDateText(this.maxValue)
                : null;
        }

        onDateInput(event: Event) {
            //console.log("date input - value = ", event.target?.value);
            this.$emit("input", Utils.parseDateText((event.target as HTMLInputElement)?.value));
        }
    }
